import { ChangePassword } from './Settings/Authentication/ChangePassword';
import { useCredentials } from '@ais-ui/auth';
import { useNavigate } from 'react-router';
import { ROUTES } from '../routes';

export const ChangePasswordPage = () => {
  const credentials = useCredentials();

  return (
    <div className="min-h-screen flex items-center justify-center p-4">
      <div className="w-full max-w-md border border-border rounded-lg p-6 bg-card shadow-sm">
        <div className="mb-6 text-center">
          <h1 className="text-2xl font-semibold text-foreground mb-2">
            Change password
          </h1>
          <p className="text-sm text-muted-foreground">
            You need to change your password for account {credentials?.username}
            .
          </p>
        </div>
        <ChangePassword
          authenticated={false}
          oldPassword={credentials?.password}
        />
      </div>
    </div>
  );
};
